let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5w5Mm")).then(() => parcelRequire('fcT12'));